type Bundle = typeof import('@yandex-int/messenger.widget')

let bundlePromise: Promise<Bundle>

export function fetchWidgetBundle(): Promise<Bundle> {
  if (!bundlePromise) {
    bundlePromise = loadMessengerWidgetBundle()
  }

  return bundlePromise
}

export const loadMessengerWidgetBundle = (): Promise<Bundle> =>
  Promise.all([
    import(/* webpackChunkName: "messenger-popup-css" */ '@yandex-int/messenger.widget/lib/ui/supportpopup.css'),
    import(/* webpackChunkName: "messenger-block-css" */ '@yandex-int/messenger.widget/lib/ui/block.css'),
  ]).then(() => import(/* webpackChunkName: "messenger-js" */ '@yandex-int/messenger.widget'))
